import { Component, OnInit, inject, signal } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { MessageModule } from 'primeng/message';
import { CommonModule } from '@angular/common';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'dc-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonModule, InputTextModule, FormsModule, MessageModule, TextareaModule],
})
export class PromptComponent implements OnInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);

  title = signal<string>('Prompt');
  message = signal<string>('');
  acceptText = signal<string>('Accept');
  cancelText = signal<string>('Cancel');
  inputValue = signal<string>('');

  ngOnInit(): void {
    this.title.set(this.config.data?.title || 'Prompt');
    this.message.set(this.config.data?.message || '');
    this.acceptText.set(this.config.data?.acceptText || 'Accept');
    this.cancelText.set(this.config.data?.cancelText || 'Cancel');
    // Set initial value if provided
    this.inputValue.set(this.config.data?.initialValue || '');
  }

  accept(): void {
    this.ref.close(this.inputValue());
  }

  cancel(): void {
    this.ref.close(null);
  }
}
